<template>
  <div class="hy">
    <div class="hy_left">
      <img src="@/assets/home_logo.png" />超级眼电脑监控系统
    </div>
    <div class="hy_right">
      <div class="hybb" v-on:click="qybbShow()">全员报表</div>
      <div class="gywm">
        <el-popover placement="right-start" trigger="click" width="354" v-model="visible">
          <div class="gywm_show">
            <div class="gywm_close" v-on:click="onclose()">X</div>
            <div class="gywm_show_logo">
              <div class="gywm_show_logo_left">
                <img src="@/assets/gywm_logo.png" width="37" height="40" />
              </div>
              <div class="gywm_show_logo_right">
                <p class="p_ty">超级眼电脑监控系统</p>
                <p class="p_ts">www.360mon.cn</p>
              </div>
            </div>
            <div class="gywm_show_tit mt35">
              <span>授权版本</span>
            </div>
            <div class="gywm_show_con">
              <p>
                版本：
                <label v-if="licType==0">试用版</label>
                <label v-if="licType==1">标准版</label>
                <label v-if="licType==2">录像版</label>
                <label v-if="licType==3">外网版</label>
                <span>授权台式：{{max_host}}台</span>
              </p>
            </div>
            <div class="gywm_show_tit mt40">
              <span>联系我们</span>
            </div>
            <div class="gywm_show_con">
              <p>客服热线：4000-186-360</p>
              <p>邮箱：support@360drm.com</p>
            </div>
          </div>
          <div slot="reference" v-on:mouseover="onGywmover()" v-on:mouseout="onGywmout()">
            <img :src="gywmSrc" />关于我们
          </div>
        </el-popover>
      </div>
      <div
        class="tcxt"
        v-on:mouseover="onOutover()"
        v-on:mouseout="onOutout()"
        v-on:click="onOut()"
      >
        <img :src="outSrc" />退出系统
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogTableVisible"
      width="1000px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="wxts_close" v-on:click="onDialogClose()">x</div>
      <p class="diglogtit">
        <label>全员统计报表</label>
      </p>
      <div class="diglogSear">
        <label>选择时间：</label>
        <div class="block">
          <el-date-picker
            style="width:170px;margin-right:20px;"
            v-model="diaLogdateTime"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </div>
        <div class="hybb" v-on:click="onScbbShow()">生成报表</div>
      </div>
      <p class="diglogTs">* 只能显示在线电脑的记录，若电脑处于离线状态则无法获取数据信息。</p>

      <el-table
        :data="tableData"
        stripe
        style="width: 100%; max-height:350px;"
        height="350"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <el-table-column prop="yname" label="员工名称"></el-table-column>
        <el-table-column label="运行时长/空闲">
          <template slot-scope="scope">
            <p>{{ scope.row.run_time }}</p>
            <p>{{ scope.row.idle_time }}</p>
          </template>
        </el-table-column>
        <el-table-column label="开机时间">
          <template slot-scope="scope">
            <p>{{ scope.row.start_time }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="chat_time" label="聊天时长"></el-table-column>
        <el-table-column prop="web_time" label="访问网页时长"></el-table-column>
        <el-table-column prop="web_count" label="网页数量"></el-table-column>
        <el-table-column prop="usb_count" label="U盘记录"></el-table-column>
        <el-table-column prop="warn_count" label="报警记录"></el-table-column>
        <el-table-column label="程序使用统计">
          <template slot-scope="scope">
            <div style="display:flex">
              <label style="margin-right:10px;">详情</label>
              <el-popover trigger="hover" placement="bottom">
                <p
                  v-for="item in scope.row.software"
                  v-bind:key="item.total"
                  style="margin-top:10px"
                >
                  <span style="display:inline-block;width:40px;">{{ item.precent }}%</span>
                  {{ item.appName }}
                </p>
                <p>{{ scope.row.date }}</p>
                <div
                  slot="reference"
                  class="name-wrapper"
                  v-on:mouseover="onScopeover(scope.row)"
                  v-on:mouseout="onScopeout(scope.row)"
                >
                  <span
                    v-show="!scope.row.icon"
                    style="height:30px;width:30px;background-color:#E3E3E3;border-radius: 30px; line-height:30px ;text-align:center; display: inline-block;"
                  >
                    <i
                      class="el-icon-caret-right"
                      style="color:#2878FF;font-size:20px;margin-top:5px;"
                    ></i>
                  </span>
                  <span
                    v-show="scope.row.icon"
                    style="height:30px;width:30px;background-color:#E3E3E3;border-radius: 30px; line-height:30px ;text-align:center;display: inline-block;"
                  >
                    <i
                      class="el-icon-caret-bottom"
                      style="color:#2878FF;font-size:20px;margin-top:5px;"
                    ></i>
                  </span>
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :visible.sync="scgbVisible"
      width="350px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="wxts_close" v-on:click="onscbgClose()">x</div>
      <div class="wxts">
        <p class="p_wxp1">
          <img src="@/assets/prompt.png" />温馨提示
        </p>
        <p class="p_wxp2">正在收集所有员工信息，请耐心等待...</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { http } from "./../../https";
export default {
  data() {
    return {
      visible: false,
      gywmSrc: require("@/assets/home_me.png"),
      outSrc: require("@/assets/home_out.png"),
      value: "",
      diaLogdateTime: "",
      tableData: [],
      dialogTableVisible: false,
      scgbVisible: false,
      loading: false,
      max_host: 0,
      licType: 0,
      timer: 0
    };
  },
  created() {
    const datas = JSON.parse(sessionStorage.getItem("datas"));
    this.max_host = datas.max_host;
    this.licType = datas.licType;
  },
  methods: {
    onclose: function() {
      this.visible = false;
    },
    onGywmover: function() {
      this.gywmSrc = require("@/assets/home_me_hover.png");
    },
    onGywmout: function() {
      this.gywmSrc = require("@/assets/home_me.png");
    },
    onOutover: function() {
      this.outSrc = require("@/assets/home_out_hover.png");
    },
    onOutout: function() {
      this.outSrc = require("@/assets/home_out.png");
    },
    qybbShow: function() {
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      const user_name = sessionStorage.getItem("user_name");
      const mac = sessionStorage.getItem("mac");
      let macSplit = mac.replace(/-/g, "");
      var timeStamp = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;
      let start_time = timeStamp;
      this.loading = true;
      if (this.diaLogdateTime != null && this.diaLogdateTime != "") {
        start_time = new Date(this.diaLogdateTime).getTime() / 1000;
      } else {
        this.diaLogdateTime = this.timestampToTime(start_time);
      }
      this.timer = setInterval(this.cscl, 4000);
      http({
        method: "GET",
        url: `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=generateReports&date=${start_time}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          if (res.code == 0) {
            clearInterval(this.timer);
            this.loading = false;
            if (res.data instanceof Array) {
              for (let s of res.data) {
                for (let d of dataGroup.server) {
                  if (s.hostname == d.host_name) {
                    s["yname"] = d.user_name;
                  }
                }
                s.data.run_time = this.formatSeconds(s.data.run_time);
                s.data.idle_time = this.formatSeconds(s.data.idle_time);
                s.data.chat_time = this.formatSeconds(s.data.chat_time);
                s.data.web_time = this.formatSeconds(s.data.web_time);
                s.data.start_time = this.timestampToTime(s.data.start_time);
                if (s.data.close_time != 0) {
                  s.data.close_time = this.timestampToTime(s.data.close_time);
                }
                for (let item of s.software) {
                  item.precent = parseInt(item.precent * 100);
                }
              }
              this.tableData = res.data;
            } else {
              this.tableData = [];
              for (let d of dataGroup.server) {
                if (res.data.hostname == d.host_name) {
                  res.data["yname"] = d.user_name;
                }
              }
              res.data.run_time = this.formatSeconds(res.data.run_time);
              res.data.idle_time = this.formatSeconds(res.data.idle_time);
              res.data.chat_time = this.formatSeconds(res.data.chat_time);
              res.data.web_time = this.formatSeconds(res.data.web_time);
              res.data.start_time = this.timestampToTime(res.data.start_time);
              if (res.data.close_time != 0) {
                res.data.close_time = this.timestampToTime(res.data.close_time);
              }
              for (let item of res.data.software) {
                item.precent = parseInt(item.precent * 100);
              }
              this.tableData.push(res.data);
            }
          } else {
            this.scgbVisible = false;
            this.loading = false;
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error"
            });
          }
        })
        .catch(res => {
          clearInterval(this.timer);
          console.log(res);
          this.scgbVisible = false;
          this.loading = false;
          this.$message({
            showClose: true,
            message: "网络错误!",
            type: "error"
          });
        });
      this.dialogTableVisible = true;
    },
    onDialogClose() {
      this.dialogTableVisible = false;
    },
    onScbbShow() {
      this.scgbVisible = true;
      this.loading = true;
      const dataGroup = JSON.parse(sessionStorage.getItem("dataGroup"));
      const user_name = sessionStorage.getItem("user_name");
      const mac = sessionStorage.getItem("mac");
      let macSplit = mac.replace(/-/g, "");
      var timeStamp = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;
      let start_time = timeStamp;
      if (this.diaLogdateTime != null && this.diaLogdateTime != "") {
        start_time = new Date(this.diaLogdateTime).getTime() / 1000;
      } else {
        this.diaLogdateTime = this.timestampToTime(start_time);
      }
      //this.timer = setInterval(this.cscl, 4000);
      http({
        method: "GET",
        url: `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=generateReports&date=${start_time}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          if (res.code == 0) {
            if (res.data instanceof Array) {
              for (let s of res.data) {
                for (let d of dataGroup.server) {
                  if (s.hostname == d.host_name) {
                    s["yname"] = d.user_name;
                  }
                }
                s.data.run_time = this.formatSeconds(s.data.run_time);
                s.data.idle_time = this.formatSeconds(s.data.idle_time);
                s.data.chat_time = this.formatSeconds(s.data.chat_time);
                s.data.web_time = this.formatSeconds(s.data.web_time);
                s.data.start_time = this.timestampToTime(s.data.start_time);
                if (s.data.close_time != 0) {
                  s.data.close_time = this.timestampToTime(s.data.close_time);
                }
                for (let item of s.software) {
                  item.precent = parseInt(item.precent * 100);
                }
              }
              this.loading = false;
              this.tableData = res.data;
            } else {
              this.loading = false;
              for (let d of dataGroup.server) {
                if (res.data.hostname == d.host_name) {
                  res.data["yname"] = d.user_name;
                }
              }
              res.data.run_time = this.formatSeconds(res.data.run_time);
              res.data.idle_time = this.formatSeconds(res.data.idle_time);
              res.data.chat_time = this.formatSeconds(res.data.chat_time);
              res.data.web_time = this.formatSeconds(res.data.web_time);
              res.data.start_time = this.timestampToTime(res.data.start_time);
              if (res.data.close_time != 0) {
                res.data.close_time = this.timestampToTime(res.data.close_time);
              }
              this.tableData = [];
              for (let item of res.data.software) {
                item.precent = parseInt(item.precent * 100);
              }
              this.tableData.push(res.data);
            }
            this.scgbVisible = false;
          } else {
            this.scgbVisible = false;
            this.loading = false;
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error"
            });
          }
        })
        .catch(res => {
          this.scgbVisible = false;
          this.loading = false;
          this.$message({
            showClose: true,
            message: "网络错误!",
            type: "error"
          });
          console.log(res);
        });
    },
    cscl() {
      this.scgbVisible = false;
      this.loading = false;
      this.$message({
        showClose: true,
        message: "报表错误!",
        type: "error"
      });
    },
    onscbgClose() {
      this.scgbVisible = false;
    },
    onScopeover(e) {
      e.icon = !e.icon;
    },
    onScopeout(e) {
      e.icon = !e.icon;
    },
    formatSeconds(value) {
      var theTime = parseInt(value); // 秒
      var middle = 0; // 分
      var hour = 0; // 小时

      if (theTime > 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle > 60) {
          hour = parseInt(middle / 60);
          middle = parseInt(middle % 60);
        }
      }
      var result = "" + parseInt(theTime) + "秒";
      if (middle > 0) {
        result = "" + parseInt(middle) + "分" + result;
      }
      if (hour > 0) {
        result = "" + parseInt(hour) + "小时" + result;
      }
      return result;
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    onOut() {
      this.$message({
        message: "退出成功",
        type: "success"
      });
      sessionStorage.clear();
      this.$router.replace("/");
    }
  }
};
</script>
<style scoped>
.hy {
  display: flex;
  padding: 10px 0px;
  justify-content: space-between;
  background: #fff;
}
.hy .hy_left {
  margin-left: 30px;
  font-size: 18px;
  font-weight: bold;
  color: rgba(86, 86, 86, 1);
}
.hy .hy_left img {
  vertical-align: middle;
  margin-right: 8px;
}
.hy .hy_right {
  margin-right: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hy .hy_right div img {
  vertical-align: middle;
}
.hy .hy_right .hybb {
  padding: 8px 24px;
  border: 1px solid rgba(223, 223, 223, 1);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 400;
  color: rgba(141, 141, 141, 1);
  margin-right: 25px;
  cursor: pointer;
}
.hy .hy_right .hybb:hover {
  background: #2878ff;
  color: #fff;
}
.hy .hy_right .gywm {
  font-size: 13px;
  font-weight: 400;
  color: rgba(164, 164, 164, 1);
  margin-right: 25px;
  cursor: pointer;
  position: relative;
}
.gywm /deep/.el-popover {
  border: 4px solid #e9e9e9;
}
.gywm_show {
  height: 265px;
  padding: 0 30px;
}
.gywm_show .gywm_close {
  position: absolute;
  right: 0;
  top: 0;
  color: #a7a7a7;
  background: #e9e9e9;
  font-size: 16px;
  padding: 5px 10px;
  cursor: pointer;
  font-weight: bold;
  border-bottom-left-radius: 20px;
}
.gywm_show .gywm_show_logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
}
.gywm_show .gywm_show_logo .gywm_show_logo_left {
  margin-right: 6px;
}
.gywm_show .gywm_show_logo .p_ty {
  font-size: 16px;
  font-weight: bold;
  color: rgba(126, 126, 126, 1);
}
.gywm_show .gywm_show_logo .p_ts {
  font-size: 12px;
  font-weight: 400;
  color: rgba(166, 166, 166, 1);
  margin-top: 1px;
}
.gywm_show .mt35 {
  margin-top: 25px;
}
.gywm_show .mt40 {
  margin-top: 30px;
}
.gywm_show .gywm_show_tit {
  font-size: 15px;
  font-weight: bold;
  color: rgba(70, 70, 70, 1);
}
.gywm_show .gywm_show_tit span {
  border-left: 5px solid #2a79fc;
  padding-left: 8px;
}
.gywm_show .gywm_show_con {
  margin-top: 14px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(70, 70, 70, 1);
  line-height: 25px;
}
.gywm_show .gywm_show_con label {
  color: #259e53;
}
.gywm_show .gywm_show_con span {
  margin-left: 20px;
}
.hy .hy_right .gywm:hover {
  color: #2878ff;
}
.hy .hy_right .gywm img {
  margin-right: 5px;
  margin-top: -5px;
}
.hy .hy_right .tcxt {
  font-size: 13px;
  font-weight: 400;
  color: rgba(164, 164, 164, 1);
  cursor: pointer;
}
.hy .hy_right .tcxt:hover {
  color: #2878ff;
}
.hy .hy_right .tcxt img {
  margin-right: 5px;
  margin-top: -5px;
}

.hy /deep/.el-table {
  margin-top: 25px;
  text-align: center;
}
.hy /deep/.el-table th {
  background: #e9e9e9;
  font-size: 13px;
  font-weight: bold;
  color: rgba(17, 17, 17, 1);
}
.hy /deep/.el-table th,
.hy /deep/.el-table td {
  text-align: center;
}
.diglogSear {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 400;
  color: rgba(141, 141, 141, 1);
  margin-top: 23px;
}
.diglogtit {
  font-size: 15px;
  font-weight: bold;
  color: rgba(70, 70, 70, 1);
}
.diglogtit label {
  border-left: 5px solid #2878ff;
  padding-left: 8px;
}
.diglogTs {
  margin-top: 25px;
  font-size: 14px;
  font-weight: bold;
  color: rgba(141, 141, 141, 1);
}
.diglogSear .hybb {
  padding: 11px 24px;
  border: 1px solid rgba(223, 223, 223, 1);
  border-radius: 5px;
  font-size: 13px;
  font-weight: 400;
  color: rgba(141, 141, 141, 1);
  margin-right: 25px;
  cursor: pointer;
}
.diglogSear .hybb:hover {
  background: #2878ff;
  color: #fff;
}

.wxts {
  text-align: center;
  padding-bottom: 40px;
}
.wxts .p_wxp1 {
  font-size: 20px;
  font-weight: bold;
  color: rgba(126, 126, 126, 1);
}
.wxts .p_wxp1 img {
  vertical-align: middle;
  margin-right: 5px;
  margin-top: -5px;
}
.wxts .p_wxp2 {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 400;
  color: rgba(164, 164, 164, 1);
}
</style>